module.exports = __webpack_public_path__ + "img/sundray.99a9f0da.png";